var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media",class:{'deletable': _vm.isDeletable}},[_c('image-loader',{attrs:{"src":_vm.media.url,"height":"80px","width":"80px","alt":""}}),_vm._v(" "),(_vm.isDeletable)?_c('span',{staticClass:"remove",on:{"click":_vm.deleteMedia}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56316bef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/libraries/media.vue
// module id = null
// module chunks = 